class Public extends CollectionPanel {

	constructor(title: string, id?: number | string, sort?: string) {
		super(title);

		this.type = CollectionType.Public;
		this.sort = sort;

		this.view();
		this.setUpEvents();
		this.getData(id);
	}
}